import { useEffect, useState } from 'react'
import { useAtomValue, useSetAtom } from 'jotai'

import * as state from '../states'
import { INoFetch, IFetchItems, EFetchReloadKey } from '../types'
import { ITokensState } from '../types'

//TODO: check\rewrite type (this one from Recoil) - is it ok?!!!
type SetterOrUpdater<T> = (valOrUpdater: (((currVal: T) => T) | T)) => void

type IFetcher<T> = (
	signal: AbortSignal,
	token?: string | null
) => Promise<IFetchItems<T>>

type IUseCommonFetch<TFetcher, TSetter> = {
	fetcher: IFetcher<TFetcher>
	jotaiSetter: SetterOrUpdater<Array<TSetter> | null>
	reloadKeyName: EFetchReloadKey
	formatter: (items: Array<TFetcher>) => Array<TSetter>
	silentMode?: boolean
}

export function useCommonFetch<TFetcher, TSetter>({
	fetcher,
	jotaiSetter,
	reloadKeyName,
	formatter,
	silentMode = false
}: IUseCommonFetch<TFetcher, TSetter>) {
	const tokens: ITokensState = useAtomValue(state.tokensAtom)
	const access = tokens?.access ?? null

	const setFetchIsLoading = useSetAtom(state.fetchIsLoadingAtom)
	const fetchIsCommonToReload = useAtomValue(state.fetchIsCommonToReloadAtom)

	const [error, setError] = useState<INoFetch | null>(null)

	const reloadKeyDep = fetchIsCommonToReload[reloadKeyName].count
	const reloadKeyDepAllList = fetchIsCommonToReload[EFetchReloadKey.allList].count

	useEffect(() => {
		const controller = new AbortController()
		const signal = controller.signal

		const call = async () => {
			try {
				!silentMode && setFetchIsLoading(state.turnOnLoader)
				const res = await fetcher(signal, access)
				const resFormat = formatter(res.items)

				setError(null)
				jotaiSetter(resFormat)
			} catch (error: unknown) {
				setError(error as INoFetch)
				jotaiSetter(null)
			} finally {
				!silentMode && setFetchIsLoading(state.turnOffLoader)
			}
		}

		call()

		return () => {
			controller.abort()
		}
	}, [
		reloadKeyDep,
		reloadKeyDepAllList,
		access,
		setFetchIsLoading,
		jotaiSetter
	])

	return {
		error
	}
}